import InformationCircleIcon from '@heroicons/react/16/solid/InformationCircleIcon';
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { Box, Grid, SvgIcon, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReporteComponente, SingleButton } from ".";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  getEnvs,
  gridSizeMdLg4,
  gridSizeMdLg8,
  useIsMediaQuery,
} from "@/shared";
import axios from "axios";
import { saveAs } from "file-saver";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { ReactNode } from "react";

const { VITE_API_URL_AWS } = getEnvs();

export type SingleTableBoxSceneProps = {
  title: string;
  children: React.ReactNode;
  py?: number;
  px?: number
  ///* boton para redireccionar pagina
  urlRedirect?: string;
  enableRedirect?: boolean;
  iconRedirect?: React.ReactNode;
  textRedirect?: string;

  ///* boton para guardar o editar
  enableCreateOrEditBtn?: boolean;
  textCreateOrEditBtn?: string;
  fnCreateOrEdit?: () => void;
  iconCreateOrEdit?: React.ReactNode;

  ///* Boton para regresar
  enableBackBtn?: boolean;
  backPageUrl?: string;

  ///* Boton adicional para generar una accion
  enableAccionBtn?: boolean;
  fnAccionBtn?: () => void;
  labelTextActionBtn?: string
  iconActionBtn?: React.ReactNode;

  ///* REPORTES
  visibleReport?: boolean;
  downloadExcel?: () => void;
  downloadPdf?: () => void;

  num_referencia?: string;

  ///* File
  enableUploadFile?: boolean;

  importationName?: string | string[];
  importationsQuantity?: number;
  fileInputRef?: any; //React.RefObject<HTMLInputElement> | 
  handleFileUpload?: any;
  enableDownloadFile?: boolean | boolean[];
  urlDownloadPlantilla?: string | string[];
  urlDownloadNameExcel?: string | string[];
  messageInToolTips?: string | string[];
  gridSizeTitle?: {
    md: number;
    lg: number;
    xs: number;
    sm: number;
  }
  gridSizeBtnAccion?: {
    md: number;
    lg: number;
    xs: number;
    sm: number;
  }
  customContentButtonSide?: React.ReactNode;
};

const SingleTableBoxScene: React.FC<SingleTableBoxSceneProps> = ({
  title,
  children,

  gridSizeTitle = gridSizeMdLg8,
  gridSizeBtnAccion = gridSizeMdLg4,
  ///* redericionar
  iconRedirect,
  enableRedirect = true,
  urlRedirect,
  textRedirect = "Crear",

  labelTextActionBtn = 'Rechazar',
  iconActionBtn,

  ///* crear o editar
  enableCreateOrEditBtn = false,
  textCreateOrEditBtn = "Guardar",
  fnCreateOrEdit,
  fnAccionBtn,
  enableBackBtn = false,
  backPageUrl,
  py = 2,
  px = 2,

  enableAccionBtn,
  num_referencia,
  iconCreateOrEdit,

  //file
  importationName = "",
  importationsQuantity = 1,
  enableUploadFile = false,
  fileInputRef,
  handleFileUpload,
  enableDownloadFile = true,
  urlDownloadPlantilla = "",
  urlDownloadNameExcel = "plantilla.xlsx",
  messageInToolTips = "",
  customContentButtonSide
}) => {
  const setAlert = useUiStore.getState().setAlert;

  const navigate = useNavigate();

  const isMobile = useIsMediaQuery("sm");

  const downloadExcel = async (url: string, fileName: string) => {
    try {
      const response = await axios.get(url, {
        responseType: "blob", // Importante para obtener el archivo como un blob
      });

      console.log(response);

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    } catch (error) {
      console.error("Error al descargar el archivo Excel:", error);
    }
  };

  //Render multiple inputs for imports
  const renderMultipleImports = (quantityOfRenders: number): ReactNode[] => {
    let nodes: ReactNode[] = [];
    for (let index = 0; index < quantityOfRenders; index++) {
      nodes.push(
        <Grid item xs={12} key={`upload-cmp-${index}`}>
          <div style={{ display: "flex" }}>
            <h3>
              {
                importationName.length > 0 && typeof (importationName) == "object" ?
                  importationName[index]?.toUpperCase()
                  :
                  `Archivo ${index + 1}`
              }
            </h3>
            {
              messageInToolTips.length > 0 && typeof (messageInToolTips) == "string" ?
                <Tooltip title={messageInToolTips} style={{ margin: "2px 5px" }}>
                  <SvgIcon fontSize="small">
                    <InformationCircleIcon />
                  </SvgIcon>
                </Tooltip>
                : messageInToolTips.length > 0 && typeof (messageInToolTips) == "object" ?
                  <Tooltip title={messageInToolTips[index]} style={{ margin: "2px 5px" }}>
                    <SvgIcon fontSize="small">
                      <InformationCircleIcon />
                    </SvgIcon>
                  </Tooltip>
                  : null
            }
          </div>
          <ReporteComponente
            fileInputRef={fileInputRef[index]}
            importExcel={handleFileUpload[index]}
            indexForInputs={index}
            downloadPlantilla={
              enableDownloadFile ?
                async () => {
                  console.log(`${VITE_API_URL_AWS}${urlDownloadPlantilla[index]}`);
                  setAlert(
                    true,
                    "En breve comenzará su descarga.",
                    AlertSeverityEnum.info
                  );
                  try {
                    await downloadExcel(
                      `${VITE_API_URL_AWS}${urlDownloadPlantilla[index]}`!,
                      `${urlDownloadNameExcel[index]}.xlsx`
                    );
                  } catch (error) {
                    setAlert(
                      true,
                      "Lo sentimos ocurrio un error al descargar la plantilla",
                      AlertSeverityEnum.error
                    );
                  }
                }
                :
                undefined
            }
          />
        </Grid>
      )
    }
    return nodes
  }

  return (
    <Box
      component="main"
      sx={{
        position: 'relative',
        flexGrow: 1,
        py: isMobile ? 3 : py,
        px: isMobile ? 1 : px,
      }}
    >
      <Grid container justifyContent={"space-between"} spacing={3}>
        
        <Grid item {...gridSizeTitle} >
          {num_referencia ? (
            <Typography variant="h4">
              {`${title} `}
              <span className="cliente__page--subtitle">
                (#{num_referencia})
              </span>
            </Typography>
          ) : (
            <Typography variant="h4">{title}</Typography>
          )}
        </Grid>

        <Grid
          item
          container
          justifyContent={"end"}
          spacing={1}
          {...gridSizeBtnAccion}
        >
          {enableBackBtn && backPageUrl && (
            <Grid item>
              <SingleButton
                color={'primary'}
                variant="outlined"
                label="Regresar"
                startIcon={<ArrowBackIcon />}
                onClick={() => {
                  navigate(backPageUrl);
                }}
              />
              
            </Grid>
          )}

          {enableAccionBtn && fnAccionBtn && (
            <Grid item>
              <SingleButton
                color={'primary'}
                variant="outlined"
                label={labelTextActionBtn}
                startIcon={iconActionBtn ?? <HighlightOffIcon />}
                onClick={fnAccionBtn}
              />
            </Grid>
          )}

          {enableCreateOrEditBtn && fnCreateOrEdit && (
            <Grid item>
              <SingleButton
                variant="outlined"
                color={"success"}
                label={textCreateOrEditBtn}
                startIcon={iconCreateOrEdit || <TaskAltIcon />}
                onClick={fnCreateOrEdit}
              />
            </Grid>
          )}

          {enableRedirect && urlRedirect && (
            <Grid item>
              <SingleButton
                label={textRedirect}
                startIcon={iconRedirect || <PlusIcon />}
                onClick={() => navigate(urlRedirect)}
              />
            </Grid>
          )}

          {
            customContentButtonSide && (
              <Grid {...gridSizeBtnAccion} container item gap={1}>
                {customContentButtonSide}
              </Grid>
            )
          }
        </Grid>

        {enableUploadFile && importationsQuantity == 1 && (
          <Grid item xs={12}>
            <ReporteComponente
              fileInputRef={fileInputRef}
              importExcel={handleFileUpload}
              downloadPlantilla={
                enableDownloadFile ?
                  async () => {
                    console.log(`${VITE_API_URL_AWS}${urlDownloadPlantilla}`);
                    setAlert(
                      true,
                      "En breve comenzará su descarga.",
                      AlertSeverityEnum.info
                    );
                    try {
                      await downloadExcel(
                        `${VITE_API_URL_AWS}${urlDownloadPlantilla}`!,
                        `${urlDownloadNameExcel}.xlsx`
                      );
                    } catch (error) {
                      setAlert(
                        true,
                        "Lo sentimos ocurrio un error al descargar la plantilla",
                        AlertSeverityEnum.error
                      );
                    }
                  }
                  :
                  undefined
              }
            />
          </Grid>
        )}

        {/* RENDER MORE THAN ONE IMPORT/DOWNLOAD COMPONENTS */}
        {enableUploadFile && importationsQuantity > 1 && (
          renderMultipleImports(importationsQuantity)
        )}



        <Grid item xs={12} marginTop={1}>
          {children}
        </Grid>
      </Grid>

      

    </Box>
  );
};

export default SingleTableBoxScene;
